import {
  EligibilityWellhubData,
  EligibilityWellhubParams,
} from '@/modules/Users/pages/Patient/components/RegisterPatient/RegisterPatient.types'

class EligibilityWellhub {
  toPersistence(data: EligibilityWellhubParams) {
    return {
      idPaciente: data?.idPatient,
      email: data?.email,
    }
  }

  toDomain(data): EligibilityWellhubData {
    return {
      externalId: data?.idClienteExterno,
      partnerPlanId: data?.plano,
      eligible: data?.elegivel,
      denialMessage: data?.mensagem,
    }
  }
}

export default new EligibilityWellhub()
